import { pluginFactory } from '@atlaskit/editor-common/utils';

import { aiSmartButtonAPIKey } from './ai-smart-button-api-plugin-key';
import { reducer } from './reducer';
import type { AISmartButtonAPIState } from './states';

export const createInitialState = (): AISmartButtonAPIState => {
	return {};
};

export const { createPluginState, createCommand, getPluginState } = pluginFactory(
	aiSmartButtonAPIKey,
	reducer,
	{},
);
